document.addEventListener('DOMContentLoaded', function () {
  const scrollElementQuery = 'body';
  const targetElementQuery = 'body';
  const scrollClass = 'scroll';
  const scrollElement = document.querySelector(scrollElementQuery);
  const targetElement = document.querySelector(targetElementQuery);
  let scrollElementPos =
    document.body.scrollTop || document.documentElement.scrollTop;

  if (targetElement) {
    if (scrollElementPos >= 1) {
      targetElement.classList.add(scrollClass);
    }
    document.addEventListener('scroll', (event) => {
      scrollElementPos =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (scrollElementPos >= 24) {
        targetElement.classList.add(scrollClass);
      } else {
        targetElement.classList.remove(scrollClass);
      }
      //console.log(scrollElementPos);
    });
  }
});
